import { cn } from '@lair-finance/util'
import { AppMenu } from '@/domains/header/components/Header/AppMenu'
import { MenuList } from '@/domains/header/components/Header/MenuList'
import { useResponsive } from '@/shared/hooks/useResponsive.ts'
import { HeaderContent } from '@/domains/header/components/Header/HeaderContent.tsx'
import { HeaderActions } from '@/domains/header/components/Header/HeaderActions'
import { NotificationBar } from '@/domains/header/components/Header/NotificationBar.tsx'

export function Header({ className }: { className?: string }) {
  const isDesktop = useResponsive('desktop')

  return (
    <div className={cn('flex flex-col', className)}>
      <NotificationBar />
      <HeaderContent actions={<HeaderActions />}>
        {isDesktop && (
          <div className={'inline-flex items-center gap-x-6'}>
            <AppMenu />
            <MenuList />
          </div>
        )}
      </HeaderContent>
    </div>
  )
}
